var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner owl-carousel owl-theme"},_vm._l((_vm.banners),function(banner,index){return _c('div',{key:index,staticClass:"item"},[_c('a',{attrs:{"href":"javascript:"}},[_c('img',{attrs:{"src":banner.image}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }